module.exports = __webpack_public_path__ + "a98a6bfff615f5ab8c2d37261fb4e63c.MP3";